import { useEffect } from 'react';

import CurrencyInput from '../../../components/input-currency';

export default function QuestionTypeCurrencyInput({ question, params, onChange, addError, showErrors, error, sectionId, blockId, getQuestionValue }) {
    const onComponentChange = (e) => {
        onChange(e);
        setError(e);
    }

    const setError = (e = null) => {
        const { value } = e !== null ? e.target : params;
        const val = value !== null ? value : '';

        let errors = []

        if (question.min_end_range !== null ) {
            if (value < Number(question.min_end_range)) {
                errors.push(`Currency needs to be bigger than ${question.min_end_range}`);
            } 
        }

        if (question.max_end_range !== null) {
            if (value > Number(question.max_end_range)) {
                errors.push(`Currency needs to be less than ${question.max_end_range}`);
            } 
        }

        if (question.response_required) {
           if (val.length == 0) errors.push('Currency cannot be empty');
        }

        addError(errors.length > 0, errors, sectionId, question.id);
    }

    useEffect(() => {
        setError();
    }, [])

    const newParams = {
        min: question.min_end_range,
        max: question.max_end_range,
    }

    params = Object.assign({}, newParams, params);

    return <CurrencyInput currencyType={question.currency} onChange={onComponentChange} error={showErrors && error} { ...params }/>
}